import Switch from "@components/Switch";
import ErrorIcon from "../img/error.svg";
import InputError from "@components/InputError/InputError";
import { useForm } from "react-hook-form";
import { useState } from "react";
import Button from "@components/Button";

import { sendContestAnswers } from "@api/activation";

const radioGroups = [
  {
    question: "Seit wann benutzt du glo?",
    name: "q0",
    options: [
      { id: "q0-6-11", value: "6-11 months", label: "6-11 Monate" },
      { id: "q0-12-17", value: "12-17 months", label: "12-17 Monate" },
      { id: "q0-18+", value: "18+ months", label: "18+ Monate" },
    ],
  },
  {
    question:
      "Hast du seitdem mit dem Rauchen aufgehört oder deinen Zigarettenkonsum reduziert?",
    name: "q1",
    options: [
      { id: "q1-reduced-no", value: "no", label: "Nein" },
      { id: "q1-reduced-yes", value: "yes", label: "Ja" },
    ],
  },
  {
    question:
      "Sprichst du mit Rauchern in deinem Freundes- und Familienkreis über glo?",
    name: "q2",
    options: [
      { id: "q2-talk-no", value: "no", label: "Nein" },
      { id: "q2-talk-yes", value: "yes", label: "Ja" },
    ],
  },
];

const testContestValidationRules = {
  required: {
    value: true,
    message: "Zustimmung erforderlich",
  },
};

const consentFields = [
  {
    name: "agreement",
    label:
      "Ich bestätige hiermit, dass ich seit mehr als 6 Monaten glo nutze. Mir ist bewusst, dass meine Teilnahme abgelehnt werden kann, wenn ich die nebenstehenden Bedingungen nicht erfülle, und ich entsprechend nicht zur Teilnahme an der Verlosung berechtigt bin.",
    validationRules: testContestValidationRules,
  },
  {
    name: "campaign",
    label:
      "Ich habe die <a target='_blank' rel='noopener noreferrer' href='https://api-dev.de.inspirationclub.tdy-apps.com/upload/2025-02-07/teilnahmebedingungen_testimonial-67a548f5ed379.pdf'>Bedingungen der Aktion</a> gelesen und stimme diesen zu. Ich bin damit einverstanden, dass mein Vorname, mein Alter und der Inhalt meiner glo-Story auf genannten Kanälen veröffentlicht werden dürfen.",
    validationRules: testContestValidationRules,
  },
];

const ContestForm = ({ refetchStatus }) => {
  const [sending, setSending] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const ident = "thr_testimonials";

  const textareaValue = watch("q3");

  const onSubmit = async (data) => {
    setSending(true);

    const { answers, consents } = Object.entries(data).reduce(
      (acc, [key, value]) => {
        if (key.startsWith("q")) {
          acc.answers[key] = value;
        } else {
          acc.consents[key] = value;
        }
        return acc;
      },
      { answers: {}, consents: {} }
    );
    const consentsArray = Object.entries(consents);
    const consentsWithLabels = consentsArray.map(([key], i) => {
      const consent = data[key];
      return {
        [key]: {
          value: consent,
          content: consentFields[i].label,
        },
      };
    });

    const payload = {
      contest: {
        ident: ident,
        content: {
          answers: {
            ...answers,
          },

          consents: {
            ...consentsWithLabels,
          },
        },
      },
    };
    try {
      await sendContestAnswers({ payload });
    } catch (error) {
      console.error("Error sending contest answers:", error);
    } finally {
      refetchStatus();
      setSending(false); // Ustaw stan na false, gdy wysyłanie zakończy się (sukces lub błąd)
    }
  };

  return (
    <div className="contest-form">
      <h3 className="contest-title">Bitte teile uns mit...</h3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="radio-group">
          {radioGroups.map((group, groupIndex) => (
            <div
              tabIndex={groupIndex + 1}
              className="form-group"
              key={groupIndex}
            >
              <h3 className="form-question">
                {group.question}{" "}
                {errors[group.name] && (
                  <img src={ErrorIcon} alt={"error"}></img>
                )}
              </h3>
              <div className="radio-group">
                <div className={`radio-wrapper q${groupIndex}`}>
                  {group.options.map((option) => (
                    <div key={option.id}>
                      <input
                        type="radio"
                        name={group.name}
                        id={option.id}
                        value={option.value}
                        {...register(group.name, {
                          required: "Wähle  die Antwort ",
                        })}
                      />
                      <label htmlFor={option.id}>{option.label}</label>
                    </div>
                  ))}
                </div>

                {errors[group.name] && (
                  <InputError errorMessage={"Wähle  die Antwort "} />
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="form-group">
          <h3 className="form-question">
            Gib deine glo-Story ein!
            {errors.q3 && <img src={ErrorIcon} alt={"error"}></img>}
          </h3>

          <textarea
            maxLength={1000}
            placeholder="Was ist deine ganz persönliche Erfahrung mit glo?"
            {...register("q3", {
              required: "Testimonial erforderlich ",
            })}
          />
          <div className="limit">{textareaValue?.length || 0}/ 1000</div>
          {errors.q3 && <InputError errorMessage={errors.q3.message} />}
        </div>

        {consentFields.map((field) => (
          <Switch
            key={field.name}
            errors={errors[field.name]}
            validationRules={field.validationRules}
            name={field.name}
            label={field.label}
            register={register}
          />
        ))}
        <div className="disclaimers">
          Informationen darüber, wie wir deine personenbezogenen Daten
          verarbeiten, findest du in den{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://api.de.inspirationclub.tdy-apps.com/terms/privacy-policy"
          >
            Informationen über die Verarbeitung personenbezogener
          </a>{" "}
          Daten.
        </div>

        <div className="submit-wrapper">
          <Button submit disabled={sending}>
            Jetzt abschicken
          </Button>
        </div>
      </form>
    </div>
  );
};
export default ContestForm;
